var React = require('react');

function Arrows (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M222.034 39.3565C222.034 39.3565 179.252 1.84583 114.334 1.53906C49.4169 1.23228 6.28244 38.3369 6.28244 38.3369","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeDasharray":"12 8","key":0}),React.createElement("path",{"d":"M7.53906 26.9102L5.53051 39.067L18.4692 40.8488","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Arrows.defaultProps = {"viewBox":"0 0 223 48","fill":"none"};

module.exports = Arrows;

Arrows.default = Arrows;
